import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.some";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.string.includes";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import { Component, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { showNotification, showErrors } from '@/utils/snack';
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue';
import AppDialog from '@/components/AppDialog.vue';
import AppSimpleButton from '@/components/AppSimpleButton.vue';
import GoodsDialog from '../GoodsList/script-dialog';
import { changeGoodsStatus } from '../GoodsList/gql';
import { SnackType } from '@/interfaces/snack';
import AppTab from '@/components/AppTab.vue';
import { auditStatusText } from '@/helpers/audit';
import { DealersOrderBy } from '@/interfaces/dealer';
import { findDealers } from '../DealerList/gql';
import { assignGoodToDealers, removeGoodFromDealers } from './gql';
import AppSearchBtn from '@/components/AppSearchBtn.vue';
import AppTextField from '@/components/AppTextField.vue';
import { formatCurrency } from '@/utils/currency';

var GoodsDetail = /*#__PURE__*/function (_mixins) {
  _inherits(GoodsDetail, _mixins);

  var _super = _createSuper(GoodsDetail);

  function GoodsDetail() {
    var _this;

    _classCallCheck(this, GoodsDetail);

    _this = _super.apply(this, arguments);
    _this.breadcrumbs = [{
      text: '商品管理'
    }, {
      text: '商品品类',
      to: {
        name: 'GoodsList'
      },
      exact: true
    }];
    _this.goodId = '';
    _this.formatCurrency = formatCurrency;
    _this.windowSize = {
      w: 0,
      h: 0
    };
    _this.actionsHeight = 51;
    _this.activeTab = 0;
    _this.headers = [{
      text: '姓名',
      value: 'dealer.realname',
      sortable: false
    }, {
      text: '手机号',
      value: 'dealer.user.phone',
      sortable: false
    }, {
      text: '店铺名称',
      value: 'dealer.storeName',
      sortable: false
    }, {
      text: '店铺电话',
      value: 'dealer.storePhone',
      sortable: false
    }, {
      text: '状态',
      value: 'dealer.status',
      sortable: false
    }, {
      text: '操作',
      value: 'actions',
      sortable: false,
      align: 'end'
    }];
    _this.filterHeaders = [{
      text: '姓名',
      value: 'realname',
      sortable: false
    }, {
      text: '店铺名称',
      value: 'storeName',
      sortable: false
    }, {
      text: '手机号',
      value: 'user.phone',
      sortable: false
    }];
    _this.options = {
      sortBy: ['realname'],
      sortDesc: [true]
    };
    _this.loading = false;
    _this.filterLoading = false;
    _this.dealers = [];
    _this.auditStatusText = auditStatusText;
    _this.allDealers = null;
    _this.selectedDealers = null;
    _this.DealersOrderBy = DealersOrderBy;
    _this.addDealers = {
      title: '添加经销商',
      show: false
    };
    _this.deleteDealerDialog = {
      show: false,
      text: ''
    };
    _this.filter = {
      realname: ''
    };
    _this.disPlayDealers = null;
    _this.isQuery = false;
    return _this;
  }

  _createClass(GoodsDetail, [{
    key: "filterDealersChange",
    value: function filterDealersChange(val) {
      this.disPlayDealers = val;
    }
  }, {
    key: "mounted",
    value: function () {
      var _mounted = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this$targetgoods, _this$targetgoods2;

        var id;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.onResize();

                if (this.getRole() === 'dealer') {
                  this.headers.pop();
                }

                id = this.$route.params.id;
                this.goodId = id;
                _context.next = 6;
                return this.getGoodsById(Number(this.goodId));

              case 6:
                this.targetgoods = _context.sent;
                this.dealers = (_this$targetgoods = this.targetgoods) === null || _this$targetgoods === void 0 ? void 0 : _this$targetgoods.dealerRelations;
                this.breadcrumbs.push({
                  text: "".concat((_this$targetgoods2 = this.targetgoods) === null || _this$targetgoods2 === void 0 ? void 0 : _this$targetgoods2.title)
                });
                _context.next = 11;
                return this.getAllDealers();

              case 11:
                this.disPlayDealers = this.filterDealers;

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function mounted() {
        return _mounted.apply(this, arguments);
      }

      return mounted;
    }()
  }, {
    key: "onResize",
    value: function onResize() {
      this.windowSize = {
        w: window.innerWidth,
        h: window.innerHeight
      };
    }
  }, {
    key: "changeTab",
    value: function changeTab(val) {
      this.activeTab = val;
    }
  }, {
    key: "deleteDialogConfirm",
    value: function () {
      var _deleteDialogConfirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.deleteGoodsRequest();

              case 2:
                this.$router.push({
                  name: 'GoodsList'
                });

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function deleteDialogConfirm() {
        return _deleteDialogConfirm.apply(this, arguments);
      }

      return deleteDialogConfirm;
    }()
  }, {
    key: "takeDownById",
    value: function () {
      var _takeDownById = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _this$targetgoods3;

        var msg, goodIds, status, result, _this$targetgoods4;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                msg = this.actionLabel;
                goodIds = [+this.goodId];
                status = ((_this$targetgoods3 = this.targetgoods) === null || _this$targetgoods3 === void 0 ? void 0 : _this$targetgoods3.status) === this.GoodsStatus.OFF_SHELVES ? this.GoodsStatus.ON_SHELVES : this.GoodsStatus.OFF_SHELVES;
                _context3.next = 5;
                return this.$apollo.mutate({
                  mutation: changeGoodsStatus,
                  variables: {
                    goodIds: goodIds,
                    status: status
                  }
                });

              case 5:
                result = _context3.sent;

                if (!result) {
                  _context3.next = 14;
                  break;
                }

                showNotification({
                  msg: "".concat(msg, "\u6210\u529F\uFF01"),
                  type: SnackType.Success
                });
                _context3.next = 10;
                return this.getGoodsById(+this.goodId);

              case 10:
                this.targetgoods = _context3.sent;
                this.dealers = (_this$targetgoods4 = this.targetgoods) === null || _this$targetgoods4 === void 0 ? void 0 : _this$targetgoods4.dealerRelations;
                _context3.next = 15;
                break;

              case 14:
                showNotification({
                  msg: "".concat(msg, "\u5931\u8D25\uFF01"),
                  type: SnackType.Error
                });

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function takeDownById() {
        return _takeDownById.apply(this, arguments);
      }

      return takeDownById;
    }()
  }, {
    key: "addDealersConfirm",
    value: function () {
      var _addDealersConfirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _this$selectedDealers;

        var dealers, result, goods, typedError;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                dealers = (_this$selectedDealers = this.selectedDealers) === null || _this$selectedDealers === void 0 ? void 0 : _this$selectedDealers.map(function (item) {
                  return {
                    dealerId: item.id
                  };
                });
                _context4.prev = 1;
                _context4.next = 4;
                return this.$apollo.mutate({
                  mutation: assignGoodToDealers,
                  variables: {
                    goodId: Number(this.goodId + ''),
                    dealers: dealers
                  }
                });

              case 4:
                result = _context4.sent;

                if (!result) {
                  _context4.next = 16;
                  break;
                }

                this.addDealers.show = false;
                this.filter.realname = '';
                this.selectedDealers = [];
                showNotification({
                  msg: '添加成功',
                  type: SnackType.Info
                });
                _context4.next = 12;
                return this.getGoodsById(Number(this.goodId));

              case 12:
                goods = _context4.sent;
                this.dealers = goods.dealerRelations;
                _context4.next = 17;
                break;

              case 16:
                showNotification({
                  msg: '添加失败',
                  type: SnackType.Error
                });

              case 17:
                _context4.next = 23;
                break;

              case 19:
                _context4.prev = 19;
                _context4.t0 = _context4["catch"](1);
                typedError = _context4.t0;
                showErrors(typedError.graphQLErrors);

              case 23:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[1, 19]]);
      }));

      function addDealersConfirm() {
        return _addDealersConfirm.apply(this, arguments);
      }

      return addDealersConfirm;
    }()
  }, {
    key: "deleteHandler",
    value: function deleteHandler() {}
  }, {
    key: "filterQuerySubmit",
    value: function filterQuerySubmit() {
      var _this$filterDealers;

      var realname = this.filter.realname;
      this.disPlayDealers = (_this$filterDealers = this.filterDealers) === null || _this$filterDealers === void 0 ? void 0 : _this$filterDealers.filter(function (item) {
        return item.realname.includes(realname);
      });
    }
  }, {
    key: "getAllDealers",
    value: function () {
      var _getAllDealers = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var result, typedError;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return this.$apollo.query({
                  query: findDealers,
                  variables: {
                    order: {
                      asc: true,
                      by: DealersOrderBy.realname
                    },
                    paging: {
                      skip: 0,
                      take: 500
                    }
                  }
                });

              case 3:
                result = _context5.sent;
                this.allDealers = result.data.findDealers.dealers;
                _context5.next = 11;
                break;

              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5["catch"](0);
                typedError = _context5.t0;
                showErrors(typedError.graphQLErrors);

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 7]]);
      }));

      function getAllDealers() {
        return _getAllDealers.apply(this, arguments);
      }

      return getAllDealers;
    }()
  }, {
    key: "deleteDealer",
    value: function () {
      var _deleteDealer = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(item) {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.deleteDealerDialog.show = true;
                this.deleteDealerDialog.text = "\u662F\u5426\u5220\u9664\u7ECF\u9500\u5546\uFF1A".concat(item.realname, "?");
                this.targetDealer = item;

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function deleteDealer(_x) {
        return _deleteDealer.apply(this, arguments);
      }

      return deleteDealer;
    }()
  }, {
    key: "deleteDealerConfirm",
    value: function () {
      var _deleteDealerConfirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var dealerIds, result, goods, typedError;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                dealerIds = [this.targetDealer.id];
                _context7.prev = 1;
                _context7.next = 4;
                return this.$apollo.query({
                  query: removeGoodFromDealers,
                  variables: {
                    dealerIds: dealerIds,
                    goodId: +this.goodId
                  }
                });

              case 4:
                result = _context7.sent;

                if (!result) {
                  _context7.next = 12;
                  break;
                }

                showNotification({
                  msg: '删除成功',
                  type: SnackType.Info
                });
                _context7.next = 9;
                return this.getGoodsById(Number(this.goodId));

              case 9:
                goods = _context7.sent;
                this.dealers = goods.dealerRelations;
                this.deleteDealerDialog.show = false;

              case 12:
                _context7.next = 18;
                break;

              case 14:
                _context7.prev = 14;
                _context7.t0 = _context7["catch"](1);
                typedError = _context7.t0;
                showErrors(typedError.graphQLErrors);

              case 18:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[1, 14]]);
      }));

      function deleteDealerConfirm() {
        return _deleteDealerConfirm.apply(this, arguments);
      }

      return deleteDealerConfirm;
    }()
  }, {
    key: "addDealersCancel",
    value: function addDealersCancel() {
      this.selectedDealers = [];
      this.disPlayDealers = this.filterDealers;
      this.filter.realname = '';
    }
  }, {
    key: "modifiedBy",
    get: function get() {
      var _this$targetgoods5;

      return ((_this$targetgoods5 = this.targetgoods) === null || _this$targetgoods5 === void 0 ? void 0 : _this$targetgoods5.managers.modifiedBy.username) || '-';
    }
  }, {
    key: "createdBy",
    get: function get() {
      var _this$targetgoods6;

      return ((_this$targetgoods6 = this.targetgoods) === null || _this$targetgoods6 === void 0 ? void 0 : _this$targetgoods6.managers.createdBy.username) || '-';
    }
  }, {
    key: "editTime",
    get: function get() {
      var _this$targetgoods7;

      return this.utcDateTimeToLocal(((_this$targetgoods7 = this.targetgoods) === null || _this$targetgoods7 === void 0 ? void 0 : _this$targetgoods7.updatedAt) + '') || '-';
    }
  }, {
    key: "actionLabel",
    get: function get() {
      var _this$targetgoods8;

      return ((_this$targetgoods8 = this.targetgoods) === null || _this$targetgoods8 === void 0 ? void 0 : _this$targetgoods8.status) === 'OFF_SHELVES' ? '上架' : '下架';
    }
  }, {
    key: "thumb",
    get: function get() {
      var _this$targetgoods9, _this$targetgoods10;

      return ((_this$targetgoods9 = this.targetgoods) === null || _this$targetgoods9 === void 0 ? void 0 : _this$targetgoods9.thumb) || ((_this$targetgoods10 = this.targetgoods) === null || _this$targetgoods10 === void 0 ? void 0 : _this$targetgoods10.coverImages[0]) || '';
    }
  }, {
    key: "filterDealers",
    get: function get() {
      var _this$allDealers,
          _this2 = this;

      if (((_this$allDealers = this.allDealers) === null || _this$allDealers === void 0 ? void 0 : _this$allDealers.length) !== 0) {
        var _this$allDealers2;

        return (_this$allDealers2 = this.allDealers) === null || _this$allDealers2 === void 0 ? void 0 : _this$allDealers2.filter(function (item) {
          var _this2$dealers;

          return !((_this2$dealers = _this2.dealers) === null || _this2$dealers === void 0 ? void 0 : _this2$dealers.some(function (ele) {
            return ele.dealer.id === item.id;
          }));
        });
      } else {
        return [];
      }
    }
  }, {
    key: "items",
    get: function get() {
      return this.getRole() === 'dealer' ? ['商品详情'] : ['商品详情', '经销商'];
    }
  }]);

  return GoodsDetail;
}(mixins(GoodsDialog));

__decorate([Watch('filterDealers', {
  deep: true
})], GoodsDetail.prototype, "filterDealersChange", null);

GoodsDetail = __decorate([Component({
  components: {
    AppBreadcrumbs: AppBreadcrumbs,
    AppDialog: AppDialog,
    AppSimpleButton: AppSimpleButton,
    AppTab: AppTab,
    AppSearchBtn: AppSearchBtn,
    AppTextField: AppTextField
  }
})], GoodsDetail);
export default GoodsDetail;